<template>
    <component
        :is="link ? 'a' : 'button'"
        :href="link"
        class="i-button"
        :class="classes"
        :type="type"
    >
        <span class="i-button__content">
            <span
                class="i-button__icon"
                v-if="!this.$slots.icon && !withoutIcon && back"
            >
                <span class="icon-back-arrow"></span>
            </span>
            <p><slot/></p>
            <span
                class="i-button__icon"
                v-if="this.$slots.icon"
            >
                <slot name="icon"/>
            </span>
            <span
                class="i-button__icon"
                v-if="!this.$slots.icon && !withoutIcon && !back"
            >
                <span class="icon-forward-arrow"></span>
            </span>
        </span>
    </component>
</template>

<script>
import './i-button.scss';

export default {
    name: 'Button',
    props: {
        link: {
            type: String,
        },
        type: {
            type: String,
            default: 'button'
        },
        back: {
            type: Boolean,
            default: false
        },
        withoutIcon: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        classes: {
            get() {
                return {
                    'i-button_back': this.back,
                    'i-button_center': this.withoutIcon
                }
            }
        }
    }
};
</script>
